import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { FlowManagementService } from '../services/flow-management.service';
import { Base64 } from 'js-base64'
import { NotificationService } from '@progress/kendo-angular-notification';
import svgPanZoom from 'svg-pan-zoom';

export function escapeHtml(unsafe) {
  return unsafe
       .replace(/&/g, "&amp;")
       .replace(/</g, "&lt;")
       .replace(/>/g, "&gt;")
       .replace(/"/g, "&quot;")
       .replace(/'/g, "&#039;");
};

@Component({
    selector: 'app-flow-diagram',
    templateUrl: './flow-diagram.component.html',
    styleUrls: ['./flow-diagram.component.css'],
    standalone: false
})
export class FlowDiagramComponent implements OnInit {

  public diagramText = null;
  public def = null;
  @Input() public flowName = '';
  public environment = '';
  public debug = window.location.host.startsWith('localhost');
  public showDiagramText = false;
  public message = '';

  @ViewChild('template', { read: TemplateRef, static: true })
  public notificationTemplate: TemplateRef<any>;

  constructor(private flowManagementService: FlowManagementService, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.refresh();
  }

  ngOnChanges(changes: SimpleChanges) {
  
    // if (changes.hero.previousValue && changes.hero.previousValue.name !== changes.hero.currentValue.name) {
    //   oldHero = changes.hero.previousValue.name;
    // }

    // if (changes.hero.previousValue) {
    //   // console.log('Old hero is: ', changes.hero.previousValue.name);
    //   this.oldHero = changes.hero.previousValue.name;
    // }
    this.refresh();
  }

  refresh() {

    // parse into mermaid
    this.flowManagementService.getFlow(this.flowManagementService.currentEnvironment, this.flowName).toPromise().then(flow => {

      const flowData = flow;
      //this.flow.definition = flow.properties.definition;
      const definition = flow.properties.definition;
      const code = JSON.stringify(definition, undefined, 2);
      //this.model.value = this.code;
      //this.model.uri = 'workflowdefinition.json';
      this.def = code;

      this.generateMermaid(this.def);

    }, (response) => {

    });

  }

  public generateMermaid(def: string) {

    const definition = JSON.parse(def);

    let triggers = Object.keys(definition.triggers);

    let diagram = `graph TD\n`;
    let keys = {};
    let scopes = {};

    triggers.forEach(t => {

      keys[t] = `t${Object.keys(keys).length + 1}`;
      let t1 = keys[t];

      diagram += `   ${t1}["${t}"]\n`;
      //diagram += `   [*] --> ${t1}\n`
    });

    this.visit(definition, [], (key, value, path) => {

      if (typeof (value) == 'object' && ('runAfter' in value || 'actions' in value)) {
        if (keys[key] == undefined) {

          if (key == 'default') {
            const s2 = path.slice(-1)[0];
            key = `${s2}_default`;
          }  
          keys[key] = `s${Object.keys(keys).length + 1}`;

          if ('description' in value) {
            //   diagram += `   note right of ${s}\n`
            //   diagram += `      ${value['description']}\n`
            //diagram += `    style ${s} fill:#f9f,stroke:#333,stroke-width:4px`;
            //const description = value['description'].replace(/'/gi, '&apos;');
            const description = escapeHtml(value['description']);
            diagram += `   ${keys[key]}["${key}<p style='font-size:x-small; height:fit-content; word-wrap:break-word;' title='${description}'>${description}</p>"]\n`;
          }
          else {
            diagram += `   ${keys[key]}["${key}"]\n`;

          }
        }
      }
    });

    this.visit(definition, [], (key, value, path) => {
      const original_key = key;
      if (typeof (value) == 'object' && ('actions' in value || 'cases' in value)) {

        if (key == 'else') {
          return;
        }
        if (key == 'default') {
          const s2 = path.slice(-1)[0];
          key = `${s2}_default`;
        }

        if (scopes[key]==null) {
          scopes[key] = `g${Object.keys(scopes).length + 1}`;
        }
        if (keys[`/${key}`]==null) {
          keys[`/${key}`] = `s${Object.keys(keys).length + 1}`;
        }

        let type = value['type'];
        const _case = value['case'];
        if (type == null && (_case != null || original_key == 'default')) {
          type = "case";  
        }
        diagram += `   subgraph ${scopes[key]}["${key} (${type})"]\n`;
        diagram += `   ${keys[`${key}`]}\n`;
        diagram += `   ${keys[`/${key}`]}["/${key}"]\n`;

        if (!('actions' in value)) {
          return;
        }

        if ('actions' in value) {
          const nodes = Object.keys(value['actions']).map(k => keys[k]);

          nodes.forEach(s => {
            diagram += `   ${s}\n`;
          });
  
          if (nodes.length > 0) {
            const last = nodes[nodes.length - 1];
  
            // diagram += `   ${last} --> ${keys[`/${key}`]}\n`
          }            
        }

        // current element has actions.
        if (path.length > 2) {
          // not root
        }
        else {
        }
      }
    }, (key, value, path) => {
      if (typeof (value) == 'object' && ('actions' in value || 'cases' in value)) {

        if (key == 'else') {
          return;
        }
        if (key == 'default') {
          const s2 = path.slice(-1)[0];
          key = `${s2}_default`;
        }

        if ('actions' in value) {
          const actions_keys = Object.keys(value['actions']);
          if (actions_keys.length > 0) {
            const last_key = actions_keys[actions_keys.length - 1];
  
            const g = scopes[last_key];
            if (g) {
              diagram += `   ${keys[`/${last_key}`]} --> ${keys[`/${key}`]}\n`;
            }
            else {
              diagram += `   ${keys[last_key]} --> ${keys[`/${key}`]}\n`;
            }
          }  
        }

        diagram += `%% /${key}\n`;
        diagram += `   end\n`;
        //scopes[key] = `g${Object.keys(scopes).length+1}`;
      }
    });



    this.visit(definition, [], (key, value, path) => {
      const original_key = key;
      if (typeof (value) == 'object' && 'runAfter' in value) {

        let afters = Object.keys(value['runAfter']);
        let s = keys[key];

        if (afters.length == 0) {
          if (path.length == 1 /* at root */) {
            // first after trigger?
            triggers.forEach(t => {
              diagram += `   ${keys[t]} --> ${s}\n`;
            });
          }
          if (path.length > 2 && path.slice(-1)[0] == 'actions') {
            let s2 = path.slice(-2)[0];
            if (s2 == "else") {
              // in a condition, one more level.
              s2 = path.slice(-3)[0];
              diagram += `   ${keys[s2]} --Else--> ${s}\n`;
            }
            // else if (s2 == "default") {
            //   s2 = path.slice(-3)[0];
            //   diagram += `   ${keys[s2]} --Default--> ${s}\n`;
            // }
            else {
              diagram += `   ${keys[s2]} --> ${s}\n`;
            }
          }
        }
        else {
          afters.forEach(t => {

            let after = value['runAfter'][t];
            let arrow = '--';
            if (Array.isArray(after) && after.length == 1 && after[0] == "Succeeded" || after.length == 0) {
            }
            else {
              arrow = `-.${after.join(',')}.-`;
            }

            // detect if linking to a subgraph
            let g = scopes[t];
            if (g) {
              //diagram += `   ${keys[`/${t}`]} --> ${s}\n`;
              diagram += `   ${keys[`/${t}`]} ${arrow}> ${s}\n`;
            }
            else {
              diagram += `   ${keys[t]} ${arrow}> ${s}\n`;
            }

          });
        }
      }
      if (typeof (value) == 'object' && 'case' in value) {
        let s2 = path.slice(-2)[0];
        let s = keys[key];
        diagram += `   ${keys[s2]} --case--> ${s}\n`;
      }
      if (typeof (value) == 'object' && key == 'default') {
        let s2 = path.slice(-1)[0];
        key = `${s2}_default`;

        let s = keys[key];
        diagram += `   ${keys[s2]} --case--> ${s}\n`;
      }
    });

    this.diagramText = diagram;

    var output = document.getElementById('output');

    let oldDiagrams = document.querySelectorAll('div#dtheDiagram');
    oldDiagrams.forEach((oldDiagram)=>{
      oldDiagram.parentNode.removeChild(oldDiagram);
    });

    (<any>window).mermaid.initialize({
      startOnLoad: true,
      flowchart: {
        htmlLabels: true
      },
      securityLevel: 'loose'
    });
    (<any>window).mermaid.render('theDiagram', diagram, (svg) => {
      output.innerHTML = svg;
      const c = output.firstChild as HTMLElement;
      svgPanZoom(c, {
        controlIconsEnabled: true
      });
      document.querySelector('g[id="svg-pan-zoom-controls"]')?.setAttribute("transform", "translate(10 10) scale(0.75)")
    });
  }

  visit(definition: any, path: string[], visitor: (key: string, value: any, path: string[])=>void, returner: (key: string, value: any, path: string[])=>void = null) {

    if (definition == null) {
      return;
    }
    for(const [key, value] of Object.entries(definition) as [string,any]) {
      if (key == "$schema") {
        continue;
      }
      if (value == null) {
        continue;
      }  
      visitor(key, value, path);
      if (value instanceof Object){
        this.visit(value, [...path, key], visitor, returner);
        // if (more && more.length) {
        //   result.push(...more);
        // }
        returner?.(key, value, path);
        continue;
      } 
      else {
        returner?.(key, value, path);
      }
    }
  }

  onDownloadPNG(event) {
    var canvas = document.createElement('canvas');
    const container = document.getElementById('output');
    const svg = document.querySelector('#output svg');
    const box = svg.getBoundingClientRect();
    canvas.width = box.width;
    canvas.height = box.height;
    const context = canvas.getContext('2d');
    context.fillStyle = "white";
    context.fillRect(0, 0, canvas.width, canvas.height);
    var image = new Image();
    image.onload = function () {
      context.drawImage(image, 0, 0);
      var a = document.createElement('a')
      a.download = `flow-diagram.png`;
      a.href = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
      a.click();
    }
    console.warn('SVG', container.innerHTML);
    image.src = `data:image/svg+xml;base64,${Base64.encode(container.innerHTML)}`;
    event.stopPropagation();
    event.preventDefault();
    event.target.download = `flow-diagram.png`;
  };

  onDownloadSVG(event) {
    //console.log('event', event.target);
    const container = document.getElementById('output');
    var a = document.createElement('a')
    a.download = `flow-diagram.svg`;
    a.href = `data:image/svg+xml;base64,${Base64.encode(
      container.innerHTML
    )}`
    a.click();

    event.stopPropagation();
    event.preventDefault();
    event.target.download = `flow-diagram.svg`
    //console.log('event', event);
  };

  public copied(clip) {
    this.message = `Mermaid Markdown copied.`
    this.notificationService.show({
      content: this.notificationTemplate,
      animation: { type: 'fade', duration: 15 },
      type: { style: 'info', icon: true },
      //closable: true,
      position: { horizontal: 'center', vertical: 'top' }
    });
  }
}
